export const loginScreen = '/login';
export const registrationScreen = '/register';
export const setNewPassword = '/reset-password-confirm';
export const invitation = '/invitation';

export const home = '/';
export const organisationsList = '/organisations-list';
export const projectList = '/project-list';
export const activityLog = '/activity-log';
export const organisationOverview = '/organisation-overview';
export const cultureProjectOverview = 'culture-project-overview';
export const projectJournals = '/project-journals';
export const projectJournalsEntries = 'entries';
export const personalJournals = '/personal-journals';
export const personalJournalReport = 'report';
export const actionTracker = '/action-tracker';

export const newCulturalProject = 'cultural-project';
export const newProjectUsers = 'project-users';
export const culturalProjectAdvancedSettings = 'project-advanced-settings';
export const culturalProjectProcess = '/cultural-project-process';
export const publicCulturalProjectProcess = '/public-cultural-project';
export const dashboard = 'dashboard';
export const dashboardBucket = 'dashboard-drilldown';
export const personalTracker = 'personal-tracker';

export const newFeedbackFramework = 'feedback-framework';
export const feedbackNominees = '/feedback-nominees';
export const feedbackProcess = '/feedback-process';
export const newFeedbackRecipient = 'new-feedback-recipient';
export const viewNominees = 'view-nominees';

export const report = '/report';
export const teamReport = '/team-report';
export const nomineeReport = '/nominee-report';
export const nomineeReject = '/nominee-reject';
export const recipientReject = '/recipient-reject';

export const manageUsers = '/manage-users';
export const personalProjects = '/personal-projects';
export const dashboardPortfolio = '/dashboard-portfolio';
export const masterDashboardDetails = 'master-dashboard-details';
export const masterDashboardsList = 'master-dashboards-list';
export const masterDashboardKeyArea = 'master-dashboard-key-area';
export const createProject = '/create-project';
export const securitySettings = '/security-settings';

export const accountSettings = '/account-settings';
export const privacyPolicy = '/privacy-policy';
export const authenticationSetup = '/authentication-setup';
export const loginMfa = '/login-mfa';
export const loginSSOScreen = '/login-sso';
